import CheckSystem from './CheckSystem';
import './CheckSystem.scss';

export default CheckSystem;
